import { render, staticRenderFns } from "./BrandTypographyFont.vue?vue&type=template&id=080437b0&"
import script from "./BrandTypographyFont.vue?vue&type=script&lang=ts&"
export * from "./BrandTypographyFont.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTypographyFont.vue?vue&type=style&index=0&id=080437b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports